import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from '@xstyled/styled-components';
import { Image } from 'antd';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var LogoLayout = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &:hover {\n    cursor: pointer;\n  }\n  img {\n    overflow: visible;\n  }\n"])));
export var AppLogo = function AppLogo(props) {
  var disabled = props.disabled,
      srcImg = props.srcImg;

  var handleRedirectToHomePage = function handleRedirectToHomePage() {
    window.location.href = '/';
  };

  var renderAppLogo = function renderAppLogo() {
    if (disabled) {
      return /*#__PURE__*/_jsx(Image, {
        src: srcImg,
        preview: false,
        alt: "logo",
        width: 144
      });
    }

    return /*#__PURE__*/_jsx(LogoLayout, {
      onClick: handleRedirectToHomePage,
      children: /*#__PURE__*/_jsx(Image, {
        src: srcImg,
        preview: false,
        alt: "logo",
        width: 144
      })
    });
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: renderAppLogo()
  });
};